import { ComponentProps } from 'react';
import { Box, DeprecatedIcon, Typography } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';

export const LIBRARY_OBJECT_TOOLTIP_VARIANT_STYLES: {
  [key in 'card' | 'detail' | 'home' | 'libraryTable' | 'homeWithIcon']: {
    textColor: ComponentProps<typeof Typography>['color'];
    typographyVariant: ComponentProps<typeof Typography>['variant'];
    iconSize?: ComponentProps<typeof DeprecatedIcon>['size'];
    iconMargin?: ComponentProps<typeof Box>['marginRight'];
    lineHeight?: ComponentProps<typeof Typography>['lineHeight'];
  };
} = {
  card: {
    textColor: 'neutrals-n10',
    typographyVariant: 'heading3',
  },
  detail: {
    textColor: 'neutrals-n7',
    typographyVariant: 'body2',
    iconSize: 24,
    iconMargin: 12,
  },
  home: {
    textColor: 'neutrals-n10',
    typographyVariant: 'body2',
  },
  homeWithIcon: {
    textColor: 'neutrals-n10',
    typographyVariant: 'body2',
    iconSize: 16,
    iconMargin: 8,
  },
  libraryTable: {
    textColor: 'neutrals-n10',
    typographyVariant: 'body3',
    lineHeight: '24px',
  },
};

export const PLURAL_OBJECT_TYPES: { [key in ObjectType]: string } = {
  [ObjectType.UNKNOWN]: intl.formatMessage({ defaultMessage: 'objects', id: '1y4/xM' }),
  [ObjectType.METRIC]: intl.formatMessage({ defaultMessage: 'metrics', id: 'KXZHvu' }),
  [ObjectType.FUNNEL]: intl.formatMessage({ defaultMessage: 'funnels', id: 'Iky5mK' }),
  [ObjectType.RETENTION]: intl.formatMessage({ defaultMessage: 'retentions', id: 'YAKxbe' }),
  [ObjectType.TEXT]: intl.formatMessage({ defaultMessage: 'text cards', id: 'Jf3cIs' }),
  [ObjectType.SEGMENT]: intl.formatMessage({ defaultMessage: 'segments', id: 'MnCxQd' }),
  [ObjectType.DASHBOARD]: intl.formatMessage({ defaultMessage: 'dashboards', id: '5DAp91' }),
  [ObjectType.HEATMAP]: intl.formatMessage({ defaultMessage: 'heatmaps', id: 'KnXZRd' }),
  [ObjectType.JOURNEY]: intl.formatMessage({ defaultMessage: 'journeys', id: 'seFAHk' }),
  [ObjectType.ELEMENT]: intl.formatMessage({ defaultMessage: 'elements', id: 'A+gAAN' }),
  [ObjectType.EVENT]: intl.formatMessage({ defaultMessage: 'events', id: 'yi/uLq' }),
  [ObjectType.API_EVENT]: intl.formatMessage({ defaultMessage: 'API events', id: 'C70ojO' }),
  /** PAGE already defined in VirtualDashboardId enum */
  [ObjectType.PAGE_TYPE]: intl.formatMessage({ defaultMessage: 'pages', id: 'dpse/L' }),
  [ObjectType.SPACE]: intl.formatMessage({ defaultMessage: 'spaces', id: 'ouJBlF' }),
  [ObjectType.SPEC_OBJECT_MAPPING]: intl.formatMessage({
    defaultMessage: 'spec object mappings',
    id: '7FTkEf',
  }),
  [ObjectType.SPEC_PROPERTY_MAPPING]: intl.formatMessage({
    defaultMessage: 'spec property mappings',
    id: 'LHkAOU',
  }),
  [ObjectType.PROPERTY]: intl.formatMessage({ defaultMessage: 'properties', id: 'kIm++Z' }),
  [ObjectType.DATA_TABLE]: intl.formatMessage({ defaultMessage: 'data tables', id: '7489AI' }),
};

export const MAX_DESCRIPTION_LENGTH = 200;

// TODO: @juliarapoport - update href when we have the KB article
export const PRIVATE_OBJECT_LEARN_MORE_LINK = 'https://help.fullstory.com';
